import styled from 'styled-components';
export const Container = styled.div`
display : flex;
width :100%;
margin : ${props => props.margin ? props.margin : "0"};
`;
export const Input = styled.input`
  font-size :${props => props.fontSize? props.fontSize : "16px"};
  width : 100%;
  border : 1px solid #eeeeee;
  text-align : left;
  padding : ${props => props.padding? props.padding : "15px"};
`;
export const Div = styled.div`
  display : flex;
  flex-direction : ${props => props.column ? "column" : "row"};
  margin : ${props => props.margin ? props.marin : "0"};
  justify-content : ${props => props.justifyContent ? props.justifyContent : "space-between"};
  align-items : center;
`;

export const Button = styled.button`
    background : #424242;
    color : #fff;
    border : 1px solid #424242;
    height : 100%;
    min-width : ${props => props.minWidth? props.minWidth : "75px"};
    padding : ${props => props.padding? props.padding : "15px"};
    font-size :${props => props.fontSize? props.fontSize : "16px"};
    cursor: pointer;
`
